module.exports = __webpack_public_path__ + "components/flag/static/square/ao-0164376d284b9dfcc3ebffe85f883d76.svg";